import React from 'react';
import { SvgIcon } from '../components/svgIcon';
import { SvgIconProps } from '../components/svgIcon/model';

export const KidIcon = React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <SvgIcon cacheName="kid" ref={ref as any} {...props}>
      <path
        d="M8.992 15.552a.625.625 0 1 0-1.185.396 2.81 2.81 0 0 0 2.692 1.927.625.625 0 1 0 0-1.25 1.56 1.56 0 0 1-1.507-1.073ZM10.375 12.75a.625.625 0 1 0-1.25 0v1.5a.625.625 0 1 0 1.25 0v-1.5ZM14.875 12.75a.625.625 0 1 0-1.25 0v1.5a.625.625 0 1 0 1.25 0v-1.5ZM15.255 8.688h0c1.195-2.304.505-5.095-1.432-6.695a.625.625 0 0 0-.796.964c1.514 1.25 2.024 3.409 1.119 5.155a3.133 3.133 0 0 1-4.248 1.313h-.002l-.014-.008h0l-.002-.001c-1.16-.58-1.607-2.063-.996-3.287.435-.869 1.544-1.223 2.453-.774.684.373.913 1.123.563 1.774a.625.625 0 1 0 1.1.592c.7-1.298.181-2.793-1.078-3.471h0l-.002-.001-.013-.007h0l-.002-.001c-1.489-.744-3.374-.2-4.139 1.33-.886 1.773-.288 4.035 1.546 4.958 2.102 1.133 4.807.345 5.943-1.84h0v-.001Z"
        fill="currentColor"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={0.25}
      />
      <path
        d="M9.16 5.679a.625.625 0 0 0-.47-1.158 8.895 8.895 0 0 0-5.135 5.525c-1.16.35-1.93 1.437-1.93 2.704 0 1.268.77 2.354 1.931 2.704 1.158 3.597 4.46 6.171 8.444 6.171 3.984 0 7.286-2.574 8.444-6.17 1.16-.351 1.931-1.437 1.931-2.705s-.77-2.353-1.93-2.704a8.895 8.895 0 0 0-5.135-5.525.625.625 0 1 0-.47 1.158 7.64 7.64 0 0 1 4.507 5.06c.066.24.268.42.515.455.718.102 1.263.718 1.263 1.556 0 .838-.545 1.454-1.263 1.556a.625.625 0 0 0-.514.452c-.903 3.265-3.814 5.617-7.348 5.617s-6.445-2.352-7.348-5.617a.625.625 0 0 0-.514-.452c-.718-.102-1.263-.718-1.263-1.556 0-.838.545-1.454 1.263-1.556a.625.625 0 0 0 .515-.455A7.64 7.64 0 0 1 9.16 5.68Z"
        fill="currentColor"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={0.25}
      />
    </SvgIcon>
  );
});
